import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || String(error) };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, message: "" });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-[60vh] grid place-items-center bg-[#0B0C0E] px-6 py-24">
          <div className="max-w-lg text-center">
            <div className="font-display text-4xl font-black uppercase text-amber-500">Något gick fel</div>
            <p className="mt-4 text-white/60">Sidan kunde inte visas just nu. Försök igen.</p>
            <pre className="mt-4 text-left text-xs text-white/30 font-mono whitespace-pre-wrap break-words">{this.state.message}</pre>
            <div className="mt-6 flex gap-3 justify-center">
              <button onClick={this.handleReset} className="rounded-full bg-amber-500 px-6 py-3 text-sm font-bold uppercase tracking-widest text-black hover:bg-amber-400 transition-colors">
                Försök igen
              </button>
              <a href="/" className="rounded-full border border-white/20 px-6 py-3 text-sm font-bold uppercase tracking-widest text-white hover:border-amber-500 transition-colors">
                Till startsidan
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
